// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"guidePage_wrapper__UIrDz","header":"guidePage_header__n57_G","title":"guidePage_title__1qfQp","subtitle":"guidePage_subtitle__1nYoJ","content":"guidePage_content__xij-b"};